/**
 * Согласие на использование фотографий.
 *
 * На снимке могут быть другие люди, поэтому право использовать фото
 * подтверждается явно и фиксируется вместе с генерацией. Версия текста —
 * часть доказательства: если формулировка изменится, старые согласия
 * останутся привязанными к той редакции, под которой их дали.
 *
 * Значение обязано совпадать с тем, что принимает сервер
 * (supabase/functions/_shared/moderation/types.ts → UploadConsent).
 */
export const CONSENT_VERSION = '2026-09-07';

export const CONSENT_TEXT =
  'Я вправе использовать эти фотографии, в том числе если на них есть другие люди.';

/**
 * Согласие на передачу фотографий за пределы РФ — отдельное действие, а не
 * часть согласия выше: это разные основания (право на снимок и передача
 * получателю за рубежом), и ст. 9 152-ФЗ требует конкретного согласия.
 *
 * Текст называет страну и получателей и не обещает больше, чем мы можем
 * гарантировать: у получателя запрос может храниться по его правилам.
 * Менять текст — только вместе с версией и политикой конфиденциальности.
 *
 * Значение обязано совпадать с тем, что принимает сервер
 * (supabase/functions/_shared/moderation/types.ts → UploadConsent.transfer).
 */
export const TRANSFER_CONSENT_VERSION = '2026-10-20';

export const TRANSFER_CONSENT_TEXT =
  'Даю согласие на передачу моих фотографий за пределы РФ (в США). Чтобы создать изображение, их получат сервис OpenAI и технический сервер-посредник. Имя и профиль не передаются, данные съёмки (место, устройство, время) из снимка удаляются. У нас фотографии не остаются дольше, чем нужно для создания; получатели могут некоторое время хранить запрос по своим правилам, и удаление данных у нас не удалит его у них. Поэтому не загружайте снимки, которые не хотите передавать. Передумать можно в любой момент: «Настройки» → удаление аккаунта.';
